import { LOCALE } from "../../properties/Locale";
import * as yup from "yup";

export const validateLoginForm = yup.object().shape({
  username: yup
    .string()
    .required(LOCALE.login_username + LOCALE.required_field),
  password: yup
    .string()
    .required(LOCALE.login_password + LOCALE.required_field),
});

export const validateCreateUserForm = yup.object().shape({
  teacher: yup.object().shape({
    firstName: yup
      .string()
      .required(LOCALE.login_firstname + LOCALE.required_field),
    lastName: yup
      .string()
      .required(LOCALE.login_lastname + LOCALE.required_field),
  }),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  type: yup
    .string()
    .nullable()
    .required(LOCALE.role + LOCALE.required_field),
  username: yup
    .string()
    .required(LOCALE.login_username + LOCALE.required_field),
  password: yup
    .string()
    .required(LOCALE.login_password + LOCALE.required_field),
  confirmPassword: yup
    .string()
    .required(LOCALE.login_confirm_password + LOCALE.required_field)
    .oneOf([yup.ref("password"), null], LOCALE.password_doesnt_match),
});
